import { render } from "./InvitationsView.vue?vue&type=template&id=11e99835&scoped=true"
import script from "./InvitationsView.vue?vue&type=script&lang=js"
export * from "./InvitationsView.vue?vue&type=script&lang=js"

import "./InvitationsView.vue?vue&type=style&index=0&id=11e99835&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e99835"]])

export default __exports__